/**
 * Direction arrow constants based on content direction
 */
export const ONWARD_DIR_ARROW = process.env.CONTENT_DIR === 'RTL' ? '←' : '→'
